import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Priority from 'shared/components/Priority/Priority';
import { formatCurrency, formatNumber } from 'shared/utils';
import { Typography } from '@mui/material';
import { CalculatedBudget } from '../../../../../../../../store/planStore';

const COLUMN_ALIGN_LEFT = 'left' as const;
const COLUMN_ALIGN_CENTER = 'center' as const;
const COLUMN_ALIGN_RIGHT = 'right' as const;

interface Budget {
  value: number;
  currency: string;
}

export default (currency: string) => {
  const { t } = useTranslation();
  return useMemo(
    () => [
      {
        key: 'touchpointName' as keyof CalculatedBudget,
        align: COLUMN_ALIGN_LEFT,
        width: '10%',
        label: t('calculator.table.columns.touchpoint'),
      },
      {
        key: 'touchpointFunnel' as keyof CalculatedBudget,
        align: COLUMN_ALIGN_LEFT,
        width: '21%',
        label: t('calculator.table.columns.phase'),
      },
      {
        key: 'isMandatory' as keyof CalculatedBudget,
        label: t('calculator.table.columns.priority'),
        align: COLUMN_ALIGN_LEFT,
        width: '15%',
        renderer: (value: boolean) => {
          return <Priority isMustHave={value} />;
        },
      },
      {
        key: 'budget' as keyof CalculatedBudget,
        label: `${t('calculator.table.columns.budget')} (${currency})`,
        dividerColumn: true,
        align: COLUMN_ALIGN_RIGHT,
        renderer: (value: any) => {
          return (
            <Typography fontSize="0.875rem" align="right">
              {value.value} {value.currency}
            </Typography>
          );
        },
        width: '10%',
      },
      {
        key: 'impressions' as keyof CalculatedBudget,
        label: t('calculator.table.columns.impressions'),
        format: formatNumber,
        align: COLUMN_ALIGN_RIGHT, // Corrected alignment to "right"
        width: '9%',
      },
      {
        key: 'reach' as keyof CalculatedBudget,
        label: t('calculator.table.columns.reach'),
        format: formatNumber,
        align: COLUMN_ALIGN_RIGHT, // Corrected alignment to "right"
        width: '9%',
      },
      {
        key: 'clicks' as keyof CalculatedBudget,
        label: t('calculator.table.columns.clicks'),
        format: formatNumber,
        align: COLUMN_ALIGN_RIGHT, // Corrected alignment to "right"
        width: '9%',
      },
      {
        key: 'videoViews' as keyof CalculatedBudget,
        label: t('calculator.table.columns.videoViews'),
        format: formatNumber,
        dividerColumn: true,
        align: COLUMN_ALIGN_RIGHT, // Corrected alignment to "right"
        width: '9%',
      },
      {
        key: 'segmentShare' as keyof CalculatedBudget,
        label: t('calculator.table.columns.segmentShare'),
        format: formatNumber,
        align: COLUMN_ALIGN_CENTER,
        width: '10%',
      },
    ],
    [t]
  );
};
